import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EarlyAccess from "@/components/EarlyAccess";
import Vision from "@/components/Vision";
import HowItWorks from "@/components/HowItWorks";
import Owners from "@/components/Owners";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import Marquee from "@/components/Marquee";

const LandingPage = () => {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-black text-white">
      <Header />
      <Hero />
      <EarlyAccess />
      <Marquee />
      <Vision />
      <HowItWorks />
      <Owners />
      <FAQ />
      <Footer />
    </main>
  );
};

export default LandingPage;
